import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MagasinComponent } from './magasin.component';

const routes: Routes = [
    {
        path: '',
        component: MagasinComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MagasinRoutingModule {}
